const defaultFields = [
  'commands',
  {
    key: 'id',
    field: 'id',
    title: 'id',
    label: 'id',
    sortable: true
	 },
  {
    key: 'guid',
    field: 'guid',
    title: 'guid',
    label: 'guid',
    sortable: true
	 },
  {
    key: 'companyId',
    field: 'companyId',
    title: 'companyId',
    label: 'companyId',
    sortable: true
	 },
  {
    key: 'number',
    field: 'number',
    title: 'number',
    label: 'number',
    sortable: true
	 },
  {
    key: 'name',
    field: 'name',
    title: 'name',
    label: 'name',
    sortable: true
	 },
  {
    key: 'isPrimary',
    field: 'isPrimary',
    title: 'isPrimary',
    label: 'isPrimary',
    sortable: true
	 },
  {
    key: 'physicalAddress1',
    field: 'physicalAddress1',
    title: 'physicalAddress1',
    label: 'physicalAddress1',
    sortable: true
	 },
  {
    key: 'physicalAddress2',
    field: 'physicalAddress2',
    title: 'physicalAddress2',
    label: 'physicalAddress2',
    sortable: true
	 },
  {
    key: 'physicalCity',
    field: 'physicalCity',
    title: 'physicalCity',
    label: 'physicalCity',
    sortable: true
	 },
  {
    key: 'physicalState',
    field: 'physicalState',
    title: 'physicalState',
    label: 'physicalState',
    sortable: true
	 },
  {
    key: 'physicalZipcode',
    field: 'physicalZipcode',
    title: 'physicalZipcode',
    label: 'physicalZipcode',
    sortable: true
	 },
  {
    key: 'mailingAddress1',
    field: 'mailingAddress1',
    title: 'mailingAddress1',
    label: 'mailingAddress1',
    sortable: true
	 },
  {
    key: 'mailingAddress2',
    field: 'mailingAddress2',
    title: 'mailingAddress2',
    label: 'mailingAddress2',
    sortable: true
	 },
  {
    key: 'mailingCity',
    field: 'mailingCity',
    title: 'mailingCity',
    label: 'mailingCity',
    sortable: true
	 },
  {
    key: 'mailingState',
    field: 'mailingState',
    title: 'mailingState',
    label: 'mailingState',
    sortable: true
	 },
  {
    key: 'mailingZipcode',
    field: 'mailingZipcode',
    title: 'mailingZipcode',
    label: 'mailingZipcode',
    sortable: true
	 },
  {
    key: 'shippingAddress1',
    field: 'shippingAddress1',
    title: 'shippingAddress1',
    label: 'shippingAddress1',
    sortable: true
	 },
  {
    key: 'shippingAddress2',
    field: 'shippingAddress2',
    title: 'shippingAddress2',
    label: 'shippingAddress2',
    sortable: true
	 },
  {
    key: 'shippingCity',
    field: 'shippingCity',
    title: 'shippingCity',
    label: 'shippingCity',
    sortable: true
	 },
  {
    key: 'shippingState',
    field: 'shippingState',
    title: 'shippingState',
    label: 'shippingState',
    sortable: true
	 },
  {
    key: 'shippingZipcode',
    field: 'shippingZipcode',
    title: 'shippingZipcode',
    label: 'shippingZipcode',
    sortable: true
	 },
  {
    key: 'email',
    field: 'email',
    title: 'email',
    label: 'email',
    sortable: true
	 },
  {
    key: 'phone',
    field: 'phone',
    title: 'phone',
    label: 'phone',
    sortable: true
	 },
  {
    key: 'fax',
    field: 'fax',
    title: 'fax',
    label: 'fax',
    sortable: true
	 },
  {
    key: 'createdByUserId',
    field: 'createdByUserId',
    title: 'createdByUserId',
    label: 'createdByUserId',
    sortable: true
	 },
  {
    key: 'modifiedByUserId',
    field: 'modifiedByUserId',
    title: 'modifiedByUserId',
    label: 'modifiedByUserId',
    sortable: true
	 },
  {
    key: 'dateCreated',
    field: 'dateCreated',
    title: 'dateCreated',
    label: 'dateCreated',
    sortable: true
	 },
  {
    key: 'dateModified',
    field: 'dateModified',
    title: 'dateModified',
    label: 'dateModified',
    sortable: true
	 },
  {
    key: 'active',
    field: 'active',
    title: 'active',
    label: 'active',
    sortable: true
	 },

]

export default defaultFields;
